import { useState, useCallback } from 'react';
import { Button } from '../../../components';
import contactSectionStyles from './ContactSection.module.scss';

const ContactSection = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSendEmail = useCallback(() => {
    if (!name || !email || !subject || !message) {
      alert('Please fill in all fields.');
      return;
    }
    const mailtoSubject = encodeURIComponent(subject);
    const mailtoBody = encodeURIComponent(`${message}\n\nRegards,\n${name}\n${email}`);
    const recipientEmail = "team@mobiyo.app";
    window.location.href = `mailto:${recipientEmail}?subject=${mailtoSubject}&body=${mailtoBody}`;
    setName(''); setEmail(''); setSubject(''); setMessage('');
  }, [name, email, subject, message]);

  return (
    <section id="contact-section" className={contactSectionStyles.contact} aria-labelledby="contact-title">
      <div className={contactSectionStyles.contactTitle}>
        <h2 id="contact-title">GET IN TOUCH</h2>
        <p>
          If you have any question or just want to say hi, it is time to reach out. We will get back to you as soon as possible
        </p>
      </div>
      <div className={contactSectionStyles.contactFormWrapper}>
        <div>
          <label htmlFor="contact_name">Name</label>
          <input
            id="contact_name"
            className={contactSectionStyles.contactInput}
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            aria-required="true"
          />
        </div>
        <div>
          <label htmlFor="contact_email">Email</label>
          <input
            id="contact_email"
            className={contactSectionStyles.contactInput}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-required="true"
          />
        </div>
        <div>
          <label htmlFor="contact_subject">Subject</label>
          <input
            id="contact_subject"
            className={contactSectionStyles.contactInput}
            type="text"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            aria-required="true"
          />
        </div>
        <div>
          <label htmlFor="contact_message">Message</label>
          <textarea
            id="contact_message"
            className={contactSectionStyles.contactTextarea}
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            aria-required="true"
          ></textarea>
        </div>
        <div>
          <Button onClick={handleSendEmail} label="SEND MESSAGE" variant="primary" className={contactSectionStyles.contactButton} />
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 
